export interface IDataTableItem<TData> {
    value: TData;
}

export interface DataTablePaginationState {
    pageIndex: number;
    pageSize: number;
}

export enum DataTableColumnType {
    DateTime = 'dateTime',
    String = 'string',
    Duration = 'duration',
    ExpandRow = 'expandRow'
}

export interface IDataTableColumn<TData> {
    accessorKey: string;
    header?: string;
    type?: DataTableColumnType;
    cell?: (props: {getValue: () => any; row: IDataTableItem<TData>}) => any;
    size?: number;
    enableSorting?: boolean;
}

export type TranslateFn = (token: string, data?: Record<string, any>) => string;

export interface TsDataTableProps<TData> {
    data: IDataTableItem<TData>[];
    columns: IDataTableColumn<TData>[];
    totalRows: number;
    translate: TranslateFn;
    pageIndex?: number;
    pageSize?: number;
    isLoading?: boolean;
    manualPagination?: boolean;
    onPageChange?: (pagination: DataTablePaginationState) => void;
    getRowCanExpand?: (row: IDataTableItem<TData>) => boolean;
    renderSubComponent?: (props: {row: IDataTableItem<TData>}) => React.ReactElement;
    expandedRowIndex?: number;
    initialSorting?: DataTableSortState;
    onSortingChange?: (sort: DataTableSortState | null) => void;
}

export interface DataTableSortState {
    field: string;
    desc: boolean;
}

export const DEFAULT_PAGE_SIZE = 15;
